import { ReactComponent as Moon } from "../../../assets/icons/moon.svg";
import { Switch as MuiSwitch } from "@mui/material";
import { ReactComponent as Sun } from "../../../assets/icons/sun.svg";
import { styled } from "@mui/material/styles";
import useTheme from "../../../hooks/useTheme";

const StyledDiv = styled("div")`
  position: relative;
  width: 2.5625rem;
  margin-left: -15px;
`;

const SwitchWithStyles = styled(MuiSwitch)`
  align-items: center;
  background-color: transparent;
  flex-direction: row;
  display: flex;
  width: 3.75rem;
  height: 2.4rem;

  .MuiSwitch-input {
    align-items: center;

    background-color: transparent;
  }
  &:hover {
    background-color: transparent;
    color: transparent;
  }

  .MuiSwitch-colorPrimary {
    color: ${(props) => props.theme.palette.themeSwitch.thumb};
    z-index: 1;

    &:hover {
      background-color: transparent;
    }
    .MuiSwitch-thumb {
      transform: scale(0.6);
      z-index: 1;
    }
  }
  .MuiSwitch-track {
    width: 2.5625rem;
    height: 1.25rem;
    border-radius: ${(props) => props.theme.shape.borderRadiusThemeSwitch}px;
    background-color: ${(props) => props.theme.palette.themeSwitch.background};
  }
  .Mui-checked + .MuiSwitch-track {
    background-color: ${(props) => props.theme.palette.themeSwitch.checked};
  }
`;

const ThemeSwitch = (props) => {
  const { theme, setTheme } = useTheme();
  return (
    <StyledDiv>
      <Moon
        stroke={theme === "DARK" ? "#E5E5E5" : "#3A424B"}
        style={{
          position: "absolute",
          right: -2,
          top: 15,
          zIndex: 0,
        }}
      />
      <Sun
        stroke={theme === "DARK" ? "#E5E5E5" : "#3A424B"}
        style={{ position: "absolute", left: 15, top: 14.5, zIndex: 0 }}
      />
      <SwitchWithStyles
        onChange={() =>
          theme === "LIGHT" ? setTheme("DARK") : setTheme("LIGHT")
        }
        disableRipple
        {...props}
      />
    </StyledDiv>
  );
};

export default ThemeSwitch;
